'use client';

import { SolidityValues } from './types';
import { ToolsTranslations } from '@/lib/translations/types';

interface CalculatorInputsProps {
  values: SolidityValues;
  onValuesChange: (field: keyof SolidityValues, value: number | string) => void;
  translations: ToolsTranslations['solidity'];
}

export default function CalculatorInputs({ values, onValuesChange, translations }: CalculatorInputsProps) {
  const handleInputChange = (field: keyof SolidityValues, value: string) => {
    const cleaned = value.replace(/\s/g, '');
    const numValue = parseFloat(cleaned);
    if (!isNaN(numValue) && numValue >= 0) {
      onValuesChange(field, numValue);
    }
  };

  const inputClass = "w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500";

  return (
    <div className="space-y-6">
      <div className="space-y-3">
        <label htmlFor="equity" className="block text-sm font-medium text-gray-700">{translations.equity}</label>
        <div className="relative">
          <input id="equity" type="text" value={values.equity.toLocaleString('sv-SE')} onChange={(e) => handleInputChange('equity', e.target.value)} className={inputClass} placeholder="0" />
          <span className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 text-sm">{translations.currencySuffix}</span>
        </div>
      </div>
      <div className="space-y-3">
        <label htmlFor="total-assets" className="block text-sm font-medium text-gray-700">{translations.totalAssets}</label>
        <div className="relative">
          <input id="total-assets" type="text" value={values.totalAssets.toLocaleString('sv-SE')} onChange={(e) => handleInputChange('totalAssets', e.target.value)} className={inputClass} placeholder="0" />
          <span className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 text-sm">{translations.currencySuffix}</span>
        </div>
      </div>
    </div>
  );
}


